/** @jsx jsx */
import { jsx } from '@emotion/react';
import styled from '@emotion/styled';
import colorFn from 'color';
import { colors } from '../../theme';

interface BadgeWrapperProps {
  backgroundColor: string;
  hoverBackgroundColor: string;
  textColor: string;
  [anyProp: string]: any;
}

const BadgeWrapper = styled.span<BadgeWrapperProps>`
  padding: ${(props) => props.padding || '2px 5px'};
  background: ${(props) => props.backgroundColor};
  border: 1px solid ${colors.darkerBackground};
  color: ${(props) => props.textColor};
  border-radius: 4px;
  height: 100%
  min-width: 14px;
  font-weight: bold;
  font-size: 13px;
  align-self: flex-start;
  margin-left: 1.5px;
  margin-right: 1.5px;
  white-space: nowrap;
  &:hover {
    background: ${(props) => props.hoverBackgroundColor || props.backgroundColor};
  }
`;

const Badge = ({
  children,
  backgroundColor,
  hoverBackgroundColor,
  onClick,
  border,
  fontSize,
  ...props
}: {
  children: React.ReactNode;
  backgroundColor: string;
  hoverBackgroundColor?: string;
  onClick?: any;
  border?: string;
  fontSize?: string;
  [anyProp: string]: any;
  // props: any;
}) => {
  const textColor = colorFn(backgroundColor).luminosity() < 0.5 ? 'rgba(255,255,255,0.95)' : 'rgba(0,0,0,0.95)';

  return (
    <BadgeWrapper
      css={{
        userSelect: onClick || hoverBackgroundColor ? 'none' : 'initial',
        cursor: onClick || hoverBackgroundColor ? 'pointer' : 'initial',
        fontWeight: 500,
        alignItems: 'center',
        textDecoration: 'none',
        ...(border && { border }),
        ...(fontSize ? { fontSize } : {})
      }}
      textColor={textColor}
      backgroundColor={backgroundColor}
      hoverBackgroundColor={hoverBackgroundColor}
      onClick={onClick}
      {...props}
    >
      {children}
    </BadgeWrapper>
  );
};

export default Badge;
